/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


export class StandardIntervalConfig {
  /**
  * Backup frequency, in hours. 
  */
  'intervalHours': StandardIntervalConfigIntervalHoursEnum;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "intervalHours",
      "baseName": "intervalHours",
      "type": "StandardIntervalConfigIntervalHoursEnum",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return StandardIntervalConfig.attributeTypeMap;
  }

  public constructor() {
  }
}


export enum StandardIntervalConfigIntervalHoursEnum {
  NUMBER_6 = 6,
  NUMBER_8 = 8,
  NUMBER_12 = 12
}

